/**
 * A stored minor-unit amount, as the merchant reads it.
 *
 * Every figure that came from a provider is in minor units with its own
 * currency beside it, so formatting one means answering both — which is why
 * this is shared rather than re-inlined per screen. Client-side sums of card
 * prices are ordinary numbers and do not belong here.
 */
export function formatAmount(minorUnits: number | null, currency: string | null): string {
  if (minorUnits === null) return "—";
  return new Intl.NumberFormat(undefined, {
    style: "currency",
    currency: (currency || "USD").toUpperCase(),
  }).format(minorUnits / 100);
}
